import { Avatar, Box, styled, Typography } from "@mui/material";
import { shouldForwardProp } from "@mui/styled-engine";
import { BankTransferVariant, bankTransferVariants } from "./bankTransfer.variants";

export const BankTransferRoot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "bankVariant",
})<{ bankVariant: BankTransferVariant}>(({ bankVariant }) => {

    const v = bankTransferVariants[bankVariant];

    return {
    cursor: "pointer",
    border: "1px solid",
    transition: v.transition,
    padding: v.root.padding,
    borderRadius: v.root.borderRadius,
    borderColor: v.root.borderColor,
    backgroundColor: v.root.backgroundColor,
    "&:hover": {
      boxShadow: v.root.hover.boxShadow,
      transform: v.root.hover.transform,
      borderColor: v.root.hover.borderColor,
    },
  };
});

export const BankIcon = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== "bankvariant",
})<{ bankvariant: BankTransferVariant }>(({ bankvariant }) => {
  const v = bankTransferVariants[bankvariant];
  return {
    width: v.icon.size,
    height: v.icon.size,
    borderRadius: 12,
    padding: 4,
    backgroundColor: v.icon.bg,
    color: v.icon.color,
  };
});

export const BankTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "bankvariant",
})<{ bankvariant: BankTransferVariant }>(({ bankvariant }) => {
  const v = bankTransferVariants[bankvariant];
  return {
    fontWeight: 700,
    fontSize: v.title.fontSize,
    color: v.title.color,
  };
});

export const BankDescription = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "bankVariant",
})<{ bankVariant: BankTransferVariant }>(({ bankVariant }) => {
  const v = bankTransferVariants[bankVariant];
  return {
    fontSize: v.description.fontSize,
    color: v.description.color,
    lineHeight: v.description.lineHeight,
    marginBottom: v.description.marginBottom,
  };
});
